export const getters = {
  modalityLocalTraining: state => state.modalityLocalTraining
}
